import Api from "./Api";
const prefix = "ratings/";
export default {
  sendUserRating(data) {
    return Api().post(prefix + "sendUserRating", data);
  },
};
